import React from "react";
import type { StickyLastAnswerSettings } from "@/types/api.types";

type StickyAnswerCtaProps = {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  settings?: StickyLastAnswerSettings;
  disabled?: boolean;
};

const StickyAnswerCta = ({
  label,
  onClick,
  settings,
  disabled = false,
}: StickyAnswerCtaProps) => {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 px-2.5 pt-3.5 pb-[calc(20px+env(safe-area-inset-bottom))] md:hidden"
      style={{ backgroundColor: settings?.barBackground ?? "#FFFFFF" }}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className="flex w-full cursor-pointer items-center justify-center px-4 leading-[22px] [text-shadow:0_1px_1px_rgba(0,0,0,0.25)] disabled:cursor-not-allowed disabled:[text-shadow:none]"
        style={{
          // Disabled colors match PrimaryButton's gray-300 / gray-500 state.
          backgroundColor: disabled
            ? "#D1D5DB"
            : (settings?.buttonBackground ?? "var(--primary)"),
          color: disabled ? "#6B7280" : (settings?.textColor ?? "#FFFFFF"),
          fontSize: settings?.fontSize ?? 16,
          fontWeight: settings?.fontWeight ?? 700,
          height: settings?.height ?? 38,
          borderRadius: settings?.borderRadius ?? 10,
        }}
      >
        {label}
      </button>
    </div>
  );
};

export default StickyAnswerCta;
